<template>
  <div class="col-lg-12">
    <form>
      <div class="row" :class="checkAllSites == true ? 'disable-dropdown' : ''">
        <div class="form-group">
          <div class="multiselect filter-form-box" id="languageSelectBox" ref="languages-select">
            <div class="selectBox show_section" @click="showCheckboxData()">
              <span ref="DataDropdownDiv">
                <div class="pt-10 sites_show_count_option">
                  <div class="sites_show_count">{{ getOptionValue() }}</div>
                </div>
              </span>
              <span v-if="getSelectedSitesCount() !== 0" :class="checkAllSites == true ? 'sites_count_data_disabled' : 'sites_count_data'">{{ getSelectedSitesCount() }}</span>
              <span v-show="errors.has('language')" class="error-style">The site must be selected.</span>
              <div class="overSelect"></div>
            </div>
            <div ref="filterDataDropdown" id="showCheckboxesData" class="select-scroll activity-builder-select-options" v-if="isDisplayDataCheckBoxes === true">
              <input type="text" class="data-search-bar" v-model="searchedData" />
              <div class="multi_select_height_alloc">
                <ul class="list-css p-0">
                  <div v-for="(data, index) in searchedDataList" :key="index">
                    <li class="main-checkbox">
                      <input type="checkbox" class="checkbox-size" :id="data.id" :checked="data.check" @click="toggleParentCheckbox" />
                      {{ data.name }}
                      <ul class="list-css">
                        <div class="check_label_input d-flex" v-for="value in data.values" :key="value.data_id">
                          <li class="sub-checkbox">
                            <input :id="value.data_id" required type="checkbox" class="checkbox-size" @change="toggleChildCheckbox" :checked="value.check" /><span class="checkbox_field_data">{{ value.display_name }}</span>
                          </li>
                        </div>
                      </ul>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group availble_data_show" v-if="selectAllSitesCheckbox() == true">
        <input type="checkbox" checked="true" class="checkbox-size" disabled="true" />
        <span class="available_list_name grey-title">Available to all sites</span>
      </div>
      <div class="form-group availble_data_show" :class="selectAllSitesCheckbox() == true ? 'hide_select_all_checkbox' : ''">
        <input type="checkbox" :checked="checkAllSites" class="checkbox-size" v-on:change="setAllCheckBoxes" :disabled="getDisableValue()" />
        <span class="available_list_name" :class="getDisableValue() == true ? 'grey-title' : ''">Available to all sites</span>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "multi-select-search",
  props: ["sitesData", "selectAllSites"],
  mounted() {
    this.openDropdownFilterDataField();
    this.sites = this.sitesData;
    this.sites.sort(this.sortSites);
    this.updateCheckboxdata("0");
    this.$root.$on("close_material", () => {
      this.searchedData = "";
      this.checkAllSites = false;
    });
    this.$root.$on("resource_uploaded", () => {
      this.checkAllSites = false;
    });
  },
  data() {
    return {
      sites: [],
      allSites: false,
      searchedData: "",
      isDisplayDataCheckBoxes: false,
      isDisplayCompletedByCheckBoxes: false,
      checkAllSites: false
    };
  },

  computed: {
    searchedDataList() {
      this.updateCheckboxdata("sitesDropdown");
      const sitesSearched = [];
      if (!this.sites) {
        return [];
      }
      if (!this.sites.length) {
        return [];
      }
      if (this.searchedData === "") {
        return this.sites;
      }
      let index = 0;
      this.sites.filter(el => {
        const flag = el.name.toLowerCase().includes(this.searchedData.toLowerCase());
        if (flag === true) {
          if (sitesSearched.length === 0) {
            sitesSearched.push(el);
          } else {
            sitesSearched.map(item => {
              if (item.name === el.name) {
                index++;
              }
            });
            if (index === 0) {
              sitesSearched.push(el);
            }
          }
        }
      });
      return sitesSearched;
    }
  },
  methods: {
    sortSites(a, b) {
      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      } else {
        return 0;
      }
    },
    getDisableValue() {
      if (this.getSelectedSitesCount() > 0 && this.checkAllSites === false) {
        return true;
      } else {
        return false;
      }
    },
    selectAllSitesCheckbox() {
      if (this.getSelectedSitesCount() === this.getSitesCount() && this.checkAllSites === false) {
        return true;
      } else {
        return false;
      }
    },
    getOptionValue() {
      if (this.getSelectedSitesCount() === 0) {
        return "Select sites";
      } else {
        return "Sites Selected";
      }
    },
    getSelectedSitesCount() {
      let count = 0;
      if (this.sites) {
        this.sites.map(el => {
          el.values.map(item => {
            if (item.check === true) {
              count++;
            }
          });
        });
      }
      return count;
    },
    getSitesCount() {
      let count = 0;
      if (this.sites) {
        this.sites.map(el => {
          el.values.map(() => {
            count++;
          });
        });
      }
      return count;
    },
    setAllCheckBoxes(event) {
      this.$emit("changeSites", event.target.checked);
      this.$store.state.allSitesSelected = event.target.checked;
      if (event.target.checked == true) {
        this.checkAllSites = true;
        this.sites.map(el => {
          el.check = true;
          el.values.map(data => {
            data.check = true;
          });
        });
      } else {
        this.checkAllSites = false;
        this.sites.map(el => {
          el.check = false;
          el.values.map(data => {
            data.check = false;
          });
        });
      }
      this.$root.$emit("resources_data_list", this.getSelectedSitesCount());
      this.$store.state.selectedSitesCount = this.getSelectedSitesCount();
      this.formatSitesData();
    },
    async formatSitesData() {
      const sitesMetaData = [];
      await this.sites.map(el => {
        el.values.map(sites => {
          const siteObj = { siteId: "", siteName: "" };
          if (sites.check === true) {
            siteObj.siteId = sites.data_id;
            siteObj.siteName = sites.display_name;
            sitesMetaData.push(siteObj);
          }
        });
      });
      this.$store.state.materialSitesData = sitesMetaData;
    },
    toggleParentCheckbox(event) {
      const checked = event.target.checked;
      const id = event.target.id;
      if (checked == true) {
        this.sites.map(el => {
          if (el.id == id) {
            el.check = true;
            el.values.map(data => {
              data.check = true;
            });
          }
        });
      } else {
        this.sites.map(el => {
          if (el.id == id) {
            el.check = false;
            el.values.map(data => {
              data.check = false;
            });
          }
        });
      }
      this.$root.$emit("resources_data_list", this.getSelectedSitesCount());
      this.formatSitesData();
      this.$store.state.selectedSitesCount = this.getSelectedSitesCount();
      this.updateCheckboxdata("sitesDropdown");
      this.$emit("setSitesdata", this.sites);
    },
    toggleChildCheckbox(event) {
      const id = event.target.id;
      const checked = event.target.checked;
      if (checked == true) {
        this.sites.map(el => {
          el.values.map(data => {
            if (data.data_id == id) {
              data.check = true;
            }
          });
        });
      } else {
        this.sites.map(el => {
          el.values.map(data => {
            if (data.data_id == id) {
              data.check = false;
            }
          });
        });
      }
      this.$store.state.selectedSitesCount = this.getSelectedSitesCount();
      this.$root.$emit("resources_data_list", this.getSelectedSitesCount());
      this.updateCheckboxdata("sitesDropdown");
      this.formatSitesData();
      this.$emit("setSitesdata", this.sites);
    },
    updateCheckboxdata() {
      const siteLen = this.sites.length;
      let selectSiteCount = 0;
      this.sites.map(el => {
        let checkboxCount = 0;
        const valLen = el.values.length;
        el.values.map(data => {
          if (data.check === true) {
            checkboxCount++;
          }
        });
        if (checkboxCount === valLen) {
          el.check = true;
          selectSiteCount++;
        } else if (checkboxCount > 0) {
          el.check = false;
        }
      });

      if (selectSiteCount === siteLen) {
        //this.checkAllSites = true;
      } else {
        //this.checkAllSites = false;
      }

      this.$root.$emit("resources_data_list", this.getSelectedSitesCount());
    },
    showCheckboxesCompletedBy() {
      this.isDisplayCompletedByCheckBoxes = !this.isDisplayCompletedByCheckBoxes;
    },
    showCheckboxData() {
      this.isDisplayDataCheckBoxes = !this.isDisplayDataCheckBoxes;
    },
    openDropdownFilterDataField() {
      document.addEventListener("click", event => {
        if (this.$refs["filterDataDropdown"] && this.$refs["filterDataDropdown"].contains(event.target)) {
          this.isDisplayDataCheckBoxes = true;
        } else if (this.$refs["DataDropdownDiv"] && this.$refs["DataDropdownDiv"].contains(event.target)) {
        } else {
          this.isDisplayDataCheckBoxes = false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.disable-dropdown {
  pointer-events: none;
  background: gainsboro;
  border-radius: 3px;
}
.grey-title {
  color: #b0bac9;
}
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.activity-form {
  //min-height: 647px;
  position: relative;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.color_959fa4 {
  color: #959fa4 !important;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
}

.hide_select_all_checkbox {
  display: none;
}

// // END of style for quick fixes bootstrap after migration (before redesign should be removed)

.bg-color {
  background-color: #f5f8fa;
  background-size: cover;
  // height: 100%;
  // min-height: 100vh;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.collapse_card {
  border: 1px solid #d3dfe4 !important;
  background-color: #f5f8fa;
  padding-left: 5px;
}
.icon_section {
  width: 28px;
  height: 28px;
  border-radius: 2px;
  background-color: #d3dfe4;
  display: inline-block;
  text-align: center;
  padding-top: 5px;
}
.read_only_card {
  border-left: 6px solid #d3dfe4 !important;
}
.navbar-style {
  background: linear-gradient(to left, #7478e6, #09b9e0);
}

.btn {
  border-radius: 25px;
}
.new-heading {
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666669;
}

.font-style {
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1f95f2;
}
.mins_text {
  position: absolute;
  top: 8px;
  right: 15px;
  color: #959fa4;
  font-size: 14px;
}
.header-style {
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}
.edit_only_screen {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.form-control {
  border-radius: 2px;
  background-color: #f5f8fa;
  height: 40px;
}

.radio-style {
  bottom: 2px;
  text-align: center;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.input-color {
  background-color: #f7f7f7;
  border: 1px solid #cccccc;
  border-radius: 3px;
}

.grey1 {
  margin-bottom: 22px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  margin-right: 10px;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.filds_section {
  border-radius: 8px;
  padding: 0 10px 10px;
  background-color: #ffffff;
  border: solid 1px #d3dfe4;
  min-height: 150px;
}

.switch-option {
  float: left;
  width: 100%;
}

.pad22 {
  padding-bottom: 22px;
}

.grpdwn,
.pt-10 {
  opacity: 0.7;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
  margin-bottom: 5px;
}

.pt-20 {
  margin-top: 100px;
  margin-bottom: 20px;
}

.back_link {
  color: #666669;
}
.survey-error {
  font-size: 14px;
  color: #f06559;
}
.modal-close {
  font-size: inherit;
  color: #000;
}
.add-tag-btn {
  cursor: pointer;
  width: 92px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 3px #4c8ce4;
  text-align: center;
  padding: 4px;
}
.add-tag-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}
.import-json-btn {
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 4px;
  border: none;
  position: relative;
  bottom: 12px;
}
.continue-btn {
  width: 122px;
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  outline: none;
}
.continue-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.cancel-btn {
  width: 122px;
  height: 36px;
  background-color: #ffffff !important;
  border-radius: 100px;
  border: solid 2px #ffffff !important;
  cursor: pointer;
  outline: none;
}
.cancel-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}
.setting-btn-text {
  position: relative;
  right: 5px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #b0bac9;
}
.required {
  color: #ff0000;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
}
.requrired-field {
  font-family: Roboto;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  line-height: 2.5;
  letter-spacing: normal;
  color: #000000;
}
.Grop-dropdown {
  height: 40px !important;
}
.add-tags {
  width: 98px;
  height: 28px;
  border-radius: 10px;
  background-color: #4c8ce4;
}

.display-tag-text {
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.4;
  letter-spacing: normal;
  display: flex;
  justify-content: center;
}
.display-tag-box {
  width: 98px;
  height: 28px;
  border-radius: 10px;
  background-color: #d3dfe4;
  cursor: pointer;
}
.display-tag-box-selected {
  width: 98px;
  height: 28px;
  border-radius: 10px;
  background-color: #4c8ce4;
  cursor: pointer;
}
.display-tag-box-selected-text {
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.4;
  letter-spacing: normal;
  color: #ffffff;
  display: flex;
  justify-content: center;
}

#showCheckboxesData {
  /* display: none; */
  background: #fff;
  position: absolute;
  top: 0px;
  width: 343px;
  height: 208px;
  border-radius: 3px;
  padding: 10px;
  // overflow-x: hidden;
  // overflow: scroll;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}
#showCheckboxesData label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  float: left;
  width: 275px;
  line-height: 30px;
}

.check_label_input input {
  float: left;
  line-height: 30px;
  margin-top: 8px;
  -webkit-margin-before: 8px;
  box-shadow: none !important;
}

.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  // background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}
.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  // top: 0;
  bottom: 0;
}
.data-search-bar {
  width: 218px;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
}
.tag-box {
  width: 45%;
}
.activity-form img {
  float: left;
  margin-top: 4px;
  margin-right: 4px;
}
.import-json-btn img {
  background-color: #fff;
  margin: 0 10px 0 0;
  border-radius: 2px;
}

select.activity-type {
  color: #000;
}
select.activity-type:focus {
  color: #000000 !important;
}

.activity-type option:first-of-type {
  color: #b0bac9;
}
.activity-type option {
  color: #000000;
  background-color: #fff;
}
select.activity-type.color-light {
  color: #b0bac9;
}

//new
.list-css,
.sub-checkbox,
.main-checkbox {
  list-style: none;
  padding-top: 0px;
  padding-bottom: 4px;
}
.checkbox-size {
  width: 18px;
  height: 18px;
  margin-top: 10px;
}

.filter-form-box select {
  width: 343px;
  font-size: 14px;
  height: 33px;
  border-radius: 3px !important;
  // background-color: #f5f8fa;
  margin: 4px 0 11px;
  padding: 0px 10.7px 0 10px;
  // color: #c5d1d6;
  border-radius: 2px;
  border: solid 1px #ced4da;
  background-image: none;
}

.data-search-bar {
  width: 322px;
  height: 29px;
  margin: 0 8px 9px 0;
  object-fit: contain;
  border-radius: 4px;
  border: solid 1px #d3dfe4;
}
.tag-box {
  width: 45%;
}
.activity-form img {
  float: left;
  margin-top: 4px;
  margin-right: 4px;
}
.import-json-btn img {
  background-color: #fff;
  margin: 0 10px 0 0;
  border-radius: 2px;
}

//new
.list-css,
.sub-checkbox,
.main-checkbox {
  list-style: none;
  padding-top: 0px;
  padding-bottom: 4px;
}
.checkbox-size {
  width: 16px;
  height: 16px;
  margin: 3px 9px 8px 8px;
}

.multi_select_height_alloc {
  overflow-x: hidden;
  height: 151px;
}

.multi_select_height_alloc {
  scrollbar-width: thin;
  scrollbar-color: #c4c4c4 transparent;
}
.multi_select_height_alloc::-webkit-scrollbar {
  width: 5px;
  border: 3px solid transparent;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
.multi_select_height_alloc::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 20px;
  border: 2px solid transparent;
}
.multi_select_height_alloc::-webkit-scrollbar-thumb:window-inactive {
  background-color: #c4c4c4;
  border-radius: 20px;
  border: 2px solid transparent;
}
.check_label_input.d-flex {
  position: relative;
  right: 14px;
}
.checkbox_field_data {
  position: relative;
  top: 5px;
  font-size: 14px;
  font-weight: 500;
  font-family: "robotoRegular";
  right: 2px;
}
.availble_data_show {
  position: relative;
  bottom: 8px;
  right: 7px;
}
.available_list_name {
  position: relative;
  bottom: 3px;
  font-size: 14px;
  font-weight: 500;
  font-family: "robotoRegular";
  right: 2px;
}
.show_section {
  select.form-control {
    width: 150px;
    margin: 3px 6px 2px 2px;
    height: 30.5px;
    padding: 0 13px 0 10px;
    border-radius: 3px;
    float: right;
    -webkit-box-shadow: inset 0 1px 2px 0 #e4e8eb;
    box-shadow: inset 0 1px 2px 0 #e4e8eb;
    border: solid 1px #e4e8eb;
    background-color: #ffffff;
  }
}
.show_section:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  color: #989898;
  right: 20px;
  top: 8px;
  height: 34px;
  padding: 0px 0px 0px 1px;
  position: absolute;
  pointer-events: none;
}

.show_section.siteId:after,
.show_section.country:after,
.show_section.langugage:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  right: 25px;
  top: 6px;
  position: absolute;
}
.sites_count_data {
  padding: 0px 6px 0px 7px;
  margin: 0px 0px 0px 12px;
  color: #fff;
  font-size: 11px;
  border-radius: 4px;
  background-color: #4c8ce4;
  font-family: "RobotoRegular";
  border-radius: 3px;
  position: absolute;
  top: 9px;
  left: 104px;
}
.sites_count_data_disabled {
  padding: 0px 6px 0px 7px;
  margin: 0px 0px 0px 12px;
  color: #fff;
  font-size: 11px;
  border-radius: 4px;
  background-color: #b0bac9;
  font-family: "RobotoRegular";
  border-radius: 3px;
  position: absolute;
  top: 9px;
  left: 104px;
}
.sites_show_count_option {
  width: 343px;
  height: 34px;
  margin: 2px 0px 17px 0px;
  padding: 1.9px 30px 0 10px;
  border-radius: 3px;
  border: solid 1px #d3dfe4;
  cursor: pointer;
}
.sites_show_count {
  position: relative;
  bottom: 4px;
}
</style>
